<template>
  <div class="pa-0 section-navbar" :class="{'lmg-font': isTargetShop}">
    <div
      style="z-index: 1;"
      class="bg-181446 pa-2 d-flex justify-space-between align-items-center"

      :style="{'--bgColor-nav': isTargetShop ? '#000' : (checkpushCustom() ? $CUSTOMMainTextColor : $bgColor)}"
    >
      <transition appear name="fade-slide">
        <p v-if="!isTargetShop" class="mb-1 bold" :style="'color:' + 'white' + ';'">
          {{ $t("message.hello") }}
        </p>
        <img v-else :src="$images.Chubb" alt="LMG-White" width="100"/>
      </transition>
      <v-badge :content="countNoti" :value="countNoti" color="red" overlap>
        <v-menu max-height="500" min-width="330" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-chip class="mr-2" @click="changlangue()" :color="!$route.path === '/RegisterMember' ? '#E2E2E2' : '#B3B3B3'" >
              <v-avatar left>
                <v-img :src="$i18n.locale === 'th' ? thai : eng"></v-img>
              </v-avatar>
              {{ $t("message.language") }}
            </v-chip>
            <transition appear name="fade-slide">
              <v-icon
                v-bind="attrs"
                v-on="on"
                style="
                  font-size: 26px;
                "
                @click="removeNoti()"
                large
              >
                mdi-bell-ring-outline
              </v-icon>
            </transition>
          </template>
          <v-card
            v-show="
              notificationshow.length > 0 || notificationshowed.length > 0
            "
          >
            <h4
              style="padding-left: 16px; margin-bottom: 0px;padding-top: 20px;"
              v-show="text === true || notificationshow.length > 0"
            >
              {{ $t("message.new") }}
            </h4>
            <div
              style="margin-bottom: 1px;padding: 10px;padding-bottom: 14px;"
              v-for="(item, i) in notificationshow"
              :key="i"
            >
              <div
                style="border: solid #dadada;padding: 7px;border-radius: 10px;"
              >
                <v-icon
                  color="#ffb000"
                  style="border-radius: 50%; width: 40px; height: 40px;"
                  >mdi-bell</v-icon
                >
                <v-chip small :color="checkColor2(item)">{{
                  checkTypeNoti(item)
                }}</v-chip>
                <div style="padding-left: 45px;">
                  <v-row
                    style="margin-top: 3px;font-size: 16px;font-weight: bold;"
                  >
                    <v-col cols="6" class="pt-0">
                      <div style="margin-bottom: 5px;">
                        {{ checkREdeemOruse(item) }}
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      class="d-flex pt-0"
                      style="justify-content: end;"
                    >
                      <span
                        :style="
                          'color:' + checkColor(item) + ';padding-right: 5px'
                        "
                        >{{ checkSymbol(item) }}
                        {{ formatNumber(item.details.split(" ")[1]) }}
                      </span>
                      {{ $t("message.point") }}
                    </v-col>
                  </v-row>
                  <div v-if="$isTargetShop && !item.lmgStatusSpecailpoint && checkShowOrNot(item)" class="mb-2" style="font-size: 13px;color: #666666;font-weight: 400; ">
                    <span class="d-flex justify-space-between">
                      - Base Point
                      <div>
                        <p class="mb-0">{{item.basePoint}} {{ $t("message.point") }}</p>
                      </div>
                    </span>
                    <span class="d-flex justify-space-between">
                    - % Tier Point
                      <div>
                        <p class="mb-0">{{parseInt(item.details.split(" ")[1]) - item.basePoint}} {{ $t("message.point") }}</p>
                      </div>
                    </span>
                  </div>
                  <div
                    style="font-size: 12px;color: #404040;margin-bottom: 10px;"
                  >
                    {{ moreDetail(item) }} {{ checkTopic(item) }}
                  </div>
                  <div style="font-size: 12px;">
                    <v-icon
                      color="#9c9c9c"
                      style="font-size: 20px;padding-bottom: 5px;"
                      >mdi-calendar</v-icon
                    >
                    <span style="color:rgb(134 134 134 / 90%);">
                      {{
                        new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                      }}
                      <span style="color: rgb(134 134 134 / 90%);">
                        <v-icon
                          color="#9c9c9c"
                          style="font-size: 20px;padding-bottom: 5px;"
                          >mdi-clock</v-icon
                        >
                        {{
                          new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                        }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <h4
              style="padding-left: 16px; margin-bottom: 10px;padding-top: 20px;font-weight: bolder;font-size: 20px;"
              v-show="notificationshowed.length > 0"
            >
              {{ $t("message.before") }}
            </h4>
            <div
              style="margin-bottom: 1px;padding: 10px;padding-bottom: 10px;"
              v-for="(item, i) in notificationshowed"
              :key="i"
            >
              <div
                style="border: solid #dadada;padding: 7px;border-radius: 10px;"
              >
                <v-icon
                  color="#ffb000"
                  style="border-radius: 50%; width: 40px; height: 40px"
                  >mdi-bell</v-icon
                >
                <v-chip small :color="checkColor2(item)">{{
                  checkTypeNoti(item)
                }}</v-chip>
                <div style="padding-left: 42px;">
                  <v-row
                    style="margin-top: 3px;font-size: 14px;font-weight: bold;"
                  >
                    <v-col cols="6" class="pt-0">
                      <div style="margin-bottom: 5px;">
                        {{ checkREdeemOruse(item) }}
                      </div>
                    </v-col>
                    <v-col
                      cols="6"
                      class="d-flex pt-0"
                      style="justify-content: end;"
                    >
                      <span
                        :style="
                          'color:' + checkColor(item) + ';padding-right: 5px'
                        "
                        >{{ checkSymbol(item) }}
                        {{ formatNumber(item.details.split(" ")[1]) }}
                      </span>
                      {{ $t("message.point") }}
                    </v-col>
                  </v-row>
                  <div v-if="$isTargetShop && !item.lmgStatusSpecailpoint && checkShowOrNot(item)" class="mb-2" style="font-size: 13px;color: #666666;font-weight: 400; ">
                        <span class="d-flex justify-space-between">
                          - Base Point
                          <div>
                            <p class="mb-0">{{item.basePoint}} {{ $t("message.point") }}</p>
                          </div>
                        </span>
                        <span class="d-flex justify-space-between">
                          - % Tier Point
                          <div>
                            <p class="mb-0">{{parseInt(item.details.split(" ")[1]) - item.basePoint}} {{ $t("message.point") }}</p>
                          </div>
                        </span>
                  </div>
                  <div
                    style="font-size: 12px;color: #404040;margin-bottom: 10px;"
                  >
                    {{ moreDetail(item) }} {{ checkTopic(item) }}
                  </div>
                  <div style="font-size: 12px;">
                    <v-icon
                      color="#9c9c9c"
                      style="font-size: 20px;padding-bottom: 5px;"
                      >mdi-calendar</v-icon
                    >
                    <span style="color:rgb(134 134 134 / 90%);">
                      {{
                        new Date(item.CREATE_DATE).toISOString().slice(0, 10)
                      }}
                      <span style="color: rgb(134 134 134 / 90%);">
                        <v-icon
                          color="#9c9c9c"
                          style="font-size: 20px;padding-bottom: 5px;"
                          >mdi-clock</v-icon
                        >
                        {{
                          new Date(item.CREATE_DATE).toISOString().slice(11, 16)
                        }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </v-badge>
    </div>

    <SectionBanner :imgCover="imgCover" v-if="baner" />

    <v-card
     v-if="baner"
      class="pa-4 ma-3"
      id="usercard"
      style="border-radius: 8px !important; position: relative;"
      :style="$isTargetShop?'bottom: 30px' : position ? `top: ${position}px` : '' "
    >
      <div v-if="profile" style="display:flex;">
        <transition appear name="fade-slide">
          <div style="align-items: center;display: flex;">
              <img
                style="
                  border-color: white;
                  height: 50px;
                  width: 50px;
                  border-radius: 40px;
                  border-style: solid;
                  border-width: 1px;
                  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
                  margin-right:6px;
                "
                alt="Avatar"
                :src="profile.pictureUrl"
              />
          </div>
        </transition>
        <div class="w-100">
          <transition appear name="fade-slide">
            <div
              class="mb-0 d-flex justify-content-between align-center mb-1 w-100"
            >
              <div :class="{'bold': !isTargetShop}">
                {{profile.displayName }}
                <v-chip v-if="newData" class="ms-2" :class="{'bold': !isTargetShop}" :color="newData.levelColor">
                  <b :style="'color:' + (newData.levelColor === '#808080FF' ? '#000' : HEXToVBColorLMG(newData.levelColor))">{{ newData.levelName}}</b>
                  <img
                    :src="isTargetShop ? $images.level : checkpushCustom() ? HEXTHEMELMG(newData.levelColor) ? $images.point : $images.pointWhite : require('@/assets/coin.png')"
                    class="ms-1"
                    width="15"
                    :style="HEXToVBColorLMG(newData.levelColor) === '#ffffff' && newData.levelColor !== '#808080FF' ? { filter: 'brightness(0) invert(1)' } : {}"
                  />
                </v-chip>
              </div>
              <img
                @click="showBarcode = true"
                src="@/assets/VectorLMG.png"
                width="20"
                height="20"
              />
            </div>
          </transition>

          <v-dialog
            v-model="menu"
            :close-on-content-click="false"
            :v-click-outside="(overlay = false)"
            nudge-bottom="30"
            nudge-left="35"
            :color="$isTargetShop ? '#ffa300': $bgColor"
          >
            <template v-slot:activator="{ on, attrs }">
              <transition appear name="fade-slide">
                <div
                  @click="(overlay = true), adddataToEditData()"
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="my-0 py-0 pr-1 text-secondary"
                >
                  {{ $t("message.detailMember") }}
                  <v-icon class="text-secondary">mdi-chevron-right</v-icon>
                </div>
              </transition>
            </template>
            <v-card>
              <v-list
                class="pa-0"
                :style="
                  'background-color: ' + ($isTargetShop ? '#ffa300' : $bgColor)
                "
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title :style="{'color': $isTargetShop ?'#000':$CUSTOMMainTextColor}">
                      <b>{{$t("message.detailMember")}}</b>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-list-item v-if="newData">
                <v-list-item-content>
                  <v-list-item-title>{{
                    $t("message.memberId")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    newData.memberId
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list class="pb-0">
                <div style="display:flex">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("message.level")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        newData.levelName
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        style="display:flex;justify-content: space-between;"
                        >{{ $t("message.nameSurname")
                        }}<v-icon
                          v-if="editName === false"
                          @click="editName = true"
                          button
                          :class="$isTargetShop ? 'd-none' : ''"
                          color="secondary"
                          class="mb-0"
                          style="font-size: 20px"
                          >mdi-pencil-circle-outline</v-icon
                        ></v-list-item-title
                      >
                      <v-list-item-subtitle
                        prepend-icon="mdi-map-marker"
                        v-if="editName === true"
                        ><v-text-field
                          v-model="editProfile.nameCustomer"
                          @click:append-outer="
                            (editName = false), save('editName')
                          "
                          append-outer-icon="mdi-content-save"
                          class="pt-0"
                          :value="editProfile.nameCustomer"
                        ></v-text-field
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle v-if="editName === false">{{
                        editProfile.nameCustomer
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <div style="display:flex">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title
                        style="display:flex;justify-content: space-between;"
                        >{{!$isTargetShop ? $t("message.tel") : $t("message.empId")
                        }} <v-icon
                          v-if="editTel === false"
                          @click="editTel = true"
                          button
                          color="secondary"
                          class="mb-0"
                          :class="$isTargetShop ? 'd-none' : ''"
                          style="font-size: 20px"
                          >mdi-pencil-circle-outline</v-icon
                        ></v-list-item-title
                      >
                      <!-- {{editProfile}} -->
                      <v-list-item-subtitle
                        prepend-icon="mdi-map-marker"
                        v-if="editTel === true"
                        ><v-text-field
                          v-model="editProfile.tel"
                          @click:append-outer="
                            (editTel = false),
                              shopId === shopNameData.bpv
                                ? optVerify()
                                : save('editTel')
                          "
                          append-outer-icon="mdi-content-save"
                          class="pt-0"
                          :value="editProfile.tel"
                        ></v-text-field
                      ></v-list-item-subtitle>
                      <v-list-item-subtitle v-if="editTel === false">{{
                        editProfile.tel
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("message.birtDay")
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        newData.birthDay
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>

              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-if="checkExchangeRate">
        <div class="mt-2 ">
          <!-- <transition appear name="fade-slide" >
            <v-col cols="6" class="pa-3"> -->
              <v-card
                style="padding: 8px;border-radius: 13px;position: relative;"
                elevation="0"
                :color="isTargetShop ? '#000': ''"
              >
                <div @click="$router.push(isTargetShop ? '/C/MyPoints' : '/MyPoints').catch(() => {})">
                  <p class="mb-0" :style="'color:' + $bgColor">
                    {{ formatNumber(newData.currentPoint) }}
                  </p>
                  <img
                    v-if="profile && profile.pictureUrl"
                    style="
                     height: 25px;
                   "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  />
                </div>
                <p class="mb-0" style="font-size: 12px;">
                  {{ $t("message.currntPoint") }}
                </p>
              </v-card>
            <!-- </v-col>
          </transition> -->
          <!-- -------------------------------เพิ่ม--------------------------------- -->
          <!-- <transition appear name="fade-slide">
            <v-col cols="6" class="pa-3"> -->
              <v-card
                style="padding: 8px;border-radius: 13px;position: relative;"
                elevation="0"
              >
                <div
                  :color="$bgColor3"
                  style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;flex-wrap: wrap; flex: 1; "
                  @click="$router.push('/C/ExchangeToDiscount').catch(() => {})"
                >
                  <p class="mb-0" :style="'color:' + $bgColor">
                    {{ $t("message.Discount") }}
                  </p>
                  <img
                    v-if="profile && profile.pictureUrl"
                    style="
                     border-color: white;
                     height: 25px;
                   "
                    alt="Avatar"
                    :src="require('@/assets/discount.png')"
                  />
                </div>
                <p class="mb-0" style="font-size: 12px;">
                  {{ $t("message.ExchangeToDiscount") }}
                </p>
              </v-card>
            <!-- </v-col>
          </transition> -->
          <!-- -----------------------------------------จบ--------------------------------- -->
        </div>
        <div class="mt-2">
          <!-- <transition appear name="fade-slide">
            <v-col cols="4" class="pa-3"> -->
              <v-card
                style="padding: 8px;border-radius: 13px;position: relative;"
                elevation="0"
              >
                <div
                  :color="$bgColor3"
                  style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;flex: 1;"
                  @click="$router.push(isTargetShop ? '/C/NewMyReward' : '/NewMyReward').catch(() => {})"
                >
                  <p class="mb-0" :style="'color:' + $bgColor">
                    {{ notExpire }}
                  </p>
                  <img
                    v-if="profile && profile.pictureUrl"
                    style="
                   border-color: white;
                   height: 25px;
                 "
                    alt="Avatar"
                    :src="require('@/assets/gift.png')"
                  />
                </div>
                <p class="mb-0" style="font-size: 12px;">
                  {{ $t("message.myReward") }}
                </p>
              </v-card>
            <!-- </v-col>
          </transition>

          <transition appear name="fade-slide">
            <v-col cols="4" class="pa-3"> -->
              <v-card
                style="padding: 8px;border-radius: 13px;position: relative;"
                elevation="0"
              >
                <div
                  :color="$bgColor3"
                  style="font-size: 20px;font-weight: bold;display: flex;justify-content: space-between; flex: 1;"
                  @click="$router.push(isTargetShop ? '/C/CredisHistory' : '/CredisHistory').catch(() => {})"
                >
                  <p class="mb-0" :style="'color:' + $bgColor">
                    {{ formatNumber(creditData.current_credits) }}
                  </p>
                  <img
                    v-if="profile && profile.pictureUrl"
                    style="
                   border-color: white;
                   height: 27px;
                 "
                    alt="Avatar"
                    :src="require('@/assets/money.png')"
                  />
                </div>
                <p class="mb-0" style="font-size: 12px;">
                  {{ $t("message.credit") }}
                </p>
              </v-card>
            <!-- </v-col>
          </transition> -->
        </div>
      </div>
      <!-- ------------------------------------------- -->
      <div v-else-if="!checkExchangeRate && check" class="pa-0">
        <div class="mt-2 px-0 d-flex" style="gap: 4px;">
              <v-card
                class="pa-2 d-flex align-center flex-column border-8-px flex-grow-1"
                :style="{'background-color': cardColor() + ' !important'}"
                @click="$router.push(isTargetShop ? '/C/MyPoints' : '/MyPoints').catch(() => {})"
                elevation="0"
              >
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">
                  {{ $t("message.currntPoint") }}
                </p>
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">
                  {{ formatNumber(newData.currentPoint) }}
                </p>
              </v-card>

              <v-card
                class="pa-2 d-flex align-center flex-column border-8-px flex-grow-1"
                :style="{'background-color': cardColor() + ' !important'}"
                @click="$router.push(isTargetShop ? '/C/NewMyReward' : '/NewMyReward').catch(() => {})"
                elevation="0"
              >
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">{{ $t("message.myReward") }}</p>
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">{{ notExpire }}</p>
              </v-card>

              <v-card
              v-if="!isTargetShop"
                class="pa-2 d-flex align-center flex-column border-8-px flex-grow-1"
                :style="{'background-color': cardColor() + ' !important'}"
                @click="$router.push(isTargetShop ? '/C/MyPoints' : '/MyPoints').catch(() => {})"
                elevation="0"
              >
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">{{ $t("message.privileges") }}</p>
                <p class="mb-0 text-white" :class="{'bold': !isTargetShop}">{{ formatNumber(myPackage)}}</p>
              </v-card>

        </div>
      </div>

      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="otpDialog"
        persistent
      >
        <v-card>
          <v-toolbar :color="$bgColor2" dark
            ><div>{{ $t("message.otpAccept") }}</div>
            <v-spacer></v-spacer
            ><v-icon @click="otpDialog = false">mdi-close</v-icon></v-toolbar
          >
          <v-card-text
            class="text-h2 px-5"
            style="font-family: Kanit !important;"
          >
            <p
              style="font-size: 15px;height: 40px;padding-left: 10px;"
              class="mb-5"
            >
              {{ $t("message.waiting") }}
            </p>
            <div class="pa-1" style="display:flex;font-size: 15px">
              <v-icon>mdi-cellphone-key</v-icon>
              <p class="mb-0 mr-3">{{ $t("message.otpSentTo") }}</p>
              <p class="mb-0">{{ editProfile.tel }}</p>
            </div>
            <v-text-field
              v-model="otpPassword"
              class="mt-5"
              :label="`${this.$t('message.enterOtp')}`"
              maxlength="4"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="success" @click="otpCheck">{{
              $t("message.confirm")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-dialog
      v-model="showBarcode"
      :fullscreen="this.theme && this.theme.barCodeData === 'True' ? false : true"
    >
      <v-toolbar
        :color="$bgColor"
        :style="{'color': $CUSTOMMainTextColor}"
        v-if="!this.theme || this.theme.barCodeData !== 'True'"
      >
        <v-toolbar-title><b>{{$isTargetShop ? 'My QR Code' :   'My QRcode'}}</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="showBarcode = false"  :style="{'color': $CUSTOMMainTextColor}">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card v-if="this.theme && this.theme.barCodeData === 'True'">
        <v-card-text
          style="padding: 10px 50px 0 !important; position: relative;top: -30px;"
        >
          <div
            style="display: flex;justify-content: center;position: relative;top: 25px;"
          >
            <v-img max-width="100" contain :src="theme.logo"></v-img>
          </div>
          <barcode
            v-if="member"
            v-bind:value="member.barcodeNum"
            style="display: flex;justify-content: center;"
          >
          </barcode>
        </v-card-text>

        <!-- <v-divider></v-divider> -->
      </v-card>

      <v-card
        v-else
        :style="
          'position: relative;display: flex;justify-content: center;padding-top: 100px !important;background-color:' + cardColor()
        "
      >
        <v-card
          style="display: flex;justify-content: center;width: 80%;height: 330px;;align-items: center;border-radius: 39px;"
        >
          <div v-if="member">
            <div
              style="justify-content: center;
             display: flex;
             top: -17px;
             position: absolute;width:150px
             "
            >
              <v-avatar size="55">
                <img :src="member.LinePicture" alt="John" />
              </v-avatar>
            </div>
            <p
              style="position: absolute;width:150px;top: 40px;text-align: center;font-size: 20px;font-weight: 900;"
            >
              {{ member.LineName }}
            </p>
            <qrcode-vue
              :value="member.tel"
              size="150"
              background="white"
              level="L"
            ></qrcode-vue>
            <div
              style="position: absolute;bottom: 36px;
   left: 0px;"
              class="mb-0 w-100 text-center"
            >
              {{ $t("message.plsStafScan") }}
            </div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" scrollable fullscreen class="dialog">
      <v-card>
        <v-card-title class="pl-5" style="border-bottom: solid #eeee"
          ><h4>แก้ไขข้อมูลส่วนตัว</h4></v-card-title
        >
        <v-card-text style="height: 300px">
          <div style="text-align: center" class="mt-6">
            <img
              v-if="editProfile.picture"
              style="
               border-color: white;
               height: 130px;
               border-radius: 100px;
               border-style: solid;
               border-width: 3px;
               box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
             "
              alt="Avatar"
              :src="editProfile.picture"
            />
          </div>
          <div class="px-4 mt-7 mb-6">
            <v-text-field
              v-model="editProfile.nameCustomer"
              label="ชื่อ-นามสกุล"
              prepend-inner-icon="mdi-account"
            ></v-text-field>
            <v-text-field
              v-model="editProfile.tel"
              label="เบอร์โทรศัพท์"
              prepend-inner-icon="mdi-cellphone"
            ></v-text-field>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  style="margin-bottom: 81px!important;"
                  v-model="editProfile.birthDay"
                  label="วันเกิด"
                  v-bind="attrs"
                  readonly
                  disabled
                  required
                  v-on="on"
                  prepend-inner-icon="mdi-cake"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker1"
                v-model="editProfile.birthDay"
                :active-date.sync="activePicker"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
              ></v-date-picker>
            </v-menu>
          </div>
          <div style="justify-content: space-around; display: flex;">
            <v-btn min-width="155" rounded @click="dialog = false">{{
              $t("message.cancle")
            }}</v-btn>
            <v-btn
              min-width="155"
              style="font-weight: bolder;"
              dark
              rounded
              color="green"
              @click="save()"
              >บันทึก</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogBirthDay" scrollable max-width="300px">
      <v-card
        max-width="300px"
        :style="
          'background-image: linear-gradient(0deg,' +
            $bgColor +
            '0%,' +
            $bgColor2 +
            '100%);'
        "
      >
        <v-card-title style="justify-content: center;color: white;"
          >Happy Birthday</v-card-title
        >
        <v-card-text style="height: 250px;">
          <img
            style="
                 height: 300px;
                 position: absolute;
                 top: 1px;
               "
            alt="Avatar"
            :src="require('@/assets/BD2.png')"
          />
        </v-card-text>
        <v-card-actions
          :style="'justify-content: center;font-size: 16px;color:' + $textcolor"
        >
          <p class="mb-0" style="font-size: 14px;">
            {{ $t("message.yougetPoint") }}
            <img
              v-if="profile && profile.pictureUrl"
              class="mx-1"
              style="
                   border-color: white;
                   height: 20px;
                   margin-bottom: 6px;
                 "
              alt="Avatar"
              :src="require('@/assets/coin.png')"
            />
            {{ point }} {{ $t("message.point") }}
          </p>
        </v-card-actions>
        <div class="my-0" style="justify-content: center;display: flex;">
          <v-btn @click="dialogBirthDay = false" color="white" icon large dark>
            <v-icon style="font-size: 30px;">mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import VueBarcode from 'vue-barcode'
import QrcodeVue from 'qrcode.vue'
import { mapGetters, mapActions } from 'vuex'

import SectionBanner from '../Layouts/SectionBanner.vue'

export default {
  name: 'HeaderProfile',
  props: {
    position: {
      type: Number,
      default: 0
    },
    imgCover: {
      type: String,
      default: null
    },
    baner: {
      type: Boolean,
      default: true
    }
  },
  components: {
    QrcodeVue,
    barcode: VueBarcode,
    SectionBanner
  },
  data () {
    return {
      check: null,
      model: null,
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: '',
        memberId: ''
      },
      menu: false,
      menu1: false,
      editTel: false,
      editName: false,
      shopId: null,
      member: null,
      otpDialog: false,
      dialogOtp: false,
      notificationshow: [],
      notificationshowed: [],
      showBarcode: false,
      countNoti: null,
      notExpire: 0,
      thai:
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng:
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      show: true,
      overlay: false,
      notishow: true,
      today: new Date(),
      langs: ['ja', 'en'],
      activePicker: null,
      text: true,
      shopInfo: null,
      theme: null,
      dialog: false,
      dialogBirthDay: false,
      point: null,
      otpPassword: '',
      myPackage: 0,
      editProfile: {
        nameCustomer: null,
        tel: null,
        birthDay: null,
        picture: null
      },
      creditData: null,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      ExchangeRate: [],
      checkExchangeRate: null
    }
  },
  computed: {
    computedStyle () {
      return this.isTargetShop ? this.fontColorLMG : this.$textcolor
    },
    isTargetShop () {
      return this.$isTargetShop()
    },
    newData () {
      return this.GET_MEMBERINFO()
    }
  },

  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'month'))
    },
    menu (a, b) {
      if (a === false) {
        setTimeout(() => {
          this.editTel = false
          this.editName = false
        }, 100)
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.theme = this.GET_THEME()
    this.profile = this.getLiffProfile()
    this.member = this.GET_MEMBERINFO()
    this.shopInfo = this.GET_SHOPINFO()
    this.shopId = this.GET_SHOPID()
    await this.getCredit()
    await this.getExchangeRate()
    await this.getPackage()
    if (!this.shopId) {
      const currentUrl = window.location.pathname
      const redirectUrl = encodeURI(currentUrl + window.location.search)
      this.$router.push('/MemberShop?redirectUrl=' + redirectUrl)
    }
    if (this.$route.query.sorce === 'getPointBirthDay') {
      let res = await axios.post(this.DNS_IP + `/getpoint/birthday`, {
        shopId: this.shopId,
        lineUserId: this.profile.userId
      })
      if (res.data.status === true) {
        this.point = res.data.point
        this.dialogBirthDay = true
      } else {
        Swal.fire({
          title: 'ผิดพลาด',
          text: res.data.message,
          icon: 'error',
          confirmButtonText: 'รับทราบ',
          confirmButtonColor: '#3085d6'
        })
      }
    }
    await this.getReward()
    await this.getMemberProfile()
    if (this.newData) {
      await this.getNotify()
      // setTimeout(async() => {
      //   await this.getNotify()
      // }, 2500)
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_SHOPINFO', 'GET_THEME']),
    checkColorImg (hex) {
      if (this.$isTargetShop()) {
        if (typeof hex === 'string' && (hex.startsWith('#000ECCFF') || hex.startsWith('#000000FF'))) {
          return '#fff'
        } else {
          return '#000'
        }
      } else {
        return this.HEXToVBColorLMG(this.newData.levelColor) ? '#000' : '#fff'
      }
    },
    checkTopic (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.refId !== '' &&
            item.refId !== 'None' &&
            item.refId !== null
          ) {
            if (item.packageName) {
              return item.packageName
            } else {
              return `${this.$t('message.billingNo')}: ${item.refId}`
            }
          } else {
            if (this.$i18n.locale === 'th') {
              return item.topicNameTh
            } else {
              return item.topicNameEng
            }
          }
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return `${this.$t('message.billingNo')}: ${item.refId}`
        }
      } else if (item.source === 'redeem') {
        if (this.$i18n.locale === 'th') {
          return item.topicNameTh
        } else {
          return item.topicNameEng
        }
      } else {
        if (item.refId !== '' && item.refId !== 'None' && item.refId !== null) {
          return `${this.$t('message.billingNo')}: ${item.refId.replace(
            /^./,
            '1'
          )}`
        } else {
        }
      }
    },
    moreDetail (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.topicNameTh === '' ||
            item.topicNameTh === null ||
            item.topicNameTh === 'None'
          ) {
            if (item.packageName) {
              return this.$t('message.fromPackage')
            } else {
              return !this.$isTargetShop ? this.$t('message.fromBuyAndService') : ''
            }
          } else {
            return this.$t('message.fromActivity')
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return this.$t('message.fromWelcome')
        } else if (
          item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ'
        ) {
          return this.$t('message.fromBuyAndService')
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return this.$t('message.fromBirth')
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return this.$t('message.fromFrigetFri')
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return this.$t('message.fromFeedBack')
        }
      } else if (item.source === 'redeem') {
        return this.$t('message.useForRedeem')
      } else if (item.source === 'expire') {
        return this.$t('message.expirePointTopic')
      } else {
        return this.$t('message.fromRefund')
      }
    },
    checkShowOrNot (item) {
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.topicNameTh === '' ||
            item.topicNameTh === null ||
            item.topicNameTh === 'None'
          ) {
            if (item.packageName) {
              return false
            } else {
              if (!this.$isTargetShop()) {
                return false
              } else {
                return item.lmgStatusSpecailpoint !== 'True'
              }
            }
          } else if (item.packageName !== null) {
            return false
          } else {
            return false
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return false
        } else if (
          item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ'
        ) {
          return false
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return false
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return false
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return false
        }
      } else if (item.source === 'redeem') {
        return false
      } else {
        if (!this.$isTargetShop()) {
          return false
        } else {
          return item.lmgStatusSpecailpoint !== 'True'
        }
      }
    },
    checkTypeNoti (item) {
      // กิจกรรม แบบสอบถาม แลกของรางวัล สินค้า/บริการ
      if (item.source === 'collect') {
        if (item.name === 'รายการรับคะแนน') {
          if (
            item.topicNameTh === '' ||
            item.topicNameTh === null ||
            item.topicNameTh === 'None'
          ) {
            if (item.packageName) {
              return this.$t('message.package')
            } else {
              if (!this.$isTargetShop()) {
                return this.$t('message.productsServices')
              } else {
                return item.lmgStatusSpecailpoint === 'True' ? this.$t('message.specailLMG') : this.$t('message.productsServicesLMG')
              }
            }
          } else if (item.packageName !== null) {
            return this.$t('message.package')
          } else {
            return this.$t('message.activity')
          }
        } else if (item.name === 'รายการรับคะแนน welcome point') {
          return this.$t('message.activity')
        } else if (
          item.name === 'รายการรับคะแนน จากการชวนเพื่อนเข้าใช้บริการ'
        ) {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนน วันเกิด') {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนนจากกิจกรรม Friend get Friend') {
          return this.$t('message.activity')
        } else if (item.name === 'รายการรับคะแนนแบบสอบถาม') {
          return this.$t('message.feedBack')
        }
      } else if (item.source === 'redeem') {
        return this.$t('message.redeemReward')
      } else if (item.source === 'expire') {
        return this.$t('message.expirePointTopic')
      } else {
        if (!this.$isTargetShop()) {
          return this.$t('message.productsServices')
        } else {
          return item.lmgStatusSpecailpoint === 'True' ? this.$t('message.specailLMG') : this.$t('message.productsServicesLMG')
        }
      }
    },
    checkColor2 (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return 'rgb(86 202 0 / 16%)'
        default:
          return 'rgb(255 76 81 / 16%)'
      }
    },
    checkColor (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return 'green'
        default:
          return 'red'
      }
    },
    checkSymbol (item) {
      switch (item.name) {
        case 'รายการรับคะแนน':
        case 'รายการรับคะแนน welcome point':
        case 'รายการรับคะแนนแบบสอบถาม':
        case 'รายการรับคะแนนจากกิจกรรม Friend get Friend':
        case 'รายการรับคะแนน วันเกิด':
          return '+'
        default:
          return '-'
      }
    },
    checkREdeemOruse (item) {
      switch (item.source) {
        case 'collect':
          return this.$t('message.yougetPoint')
        case 'redeem':
          return this.$t('message.youUsePoint')
        case 'refund':
          return this.$t('message.youRefund')
        case 'expire':
          return this.$t('message.expirePointTopic')
      }
    },
    async changlangue () {
      this.$i18n.locale = this.$i18n.locale === 'th' ? 'en' : 'th'
      await axios.post(this.DNS_IP + `/member/edit/${this.newData.memberId}`, {
        language: this.$i18n.locale
      })
      await this.getMemberProfile()
    },
    async otpCheck () {
      try {
        const data = await axios.get(
          this.DNS_IP + `/otp/get?tel=${this.editProfile.tel.trim()}`
        )
        if (data.data.length) {
          if (data.data[0].otpPassword === this.otpPassword) {
            this.save('editTel')
            this.otpPassword = ''
            this.otpDialog = false
          } else {
            this.otp = ''
            this.newData = this.GET_MEMBERINFO()
            Swal.fire({
              title: '<h5>' + `ผิดพลาด otp ไม่ถูกต้อง` + '</h5>',
              icon: 'error',
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: `${this.$t('message.confirm')}`
            })
          }
        }
      } catch (error) {
        console.error('dddd', error)
      }
    },
    async getCredit () {
      try {
        if (!this.newData || !this.newData.tel) return
        const res = await axios.get(this.DNS_IP + `/getCredits?tel=${this.newData.tel}&shopId=${this.shopId}`)
        if (res.data.length) {
          this.creditData = res.data[0]
        }
      } catch (err) {
        console.error('err:', err)
      }
      // await axios
      //   .get(
      //     this.DNS_IP +
      //       `/getCredits?tel=${this.newData.tel}&shopId=${this.shopId}`
      //   )
      //   .then(res => {
      //     this.creditData = res.data[0]
      //     console.log('creditData', this.creditData[0])
      //   })
      this.$checkCredits = true
    },
    async getNotify () {
      try {
        if (!this.profile || !this.profile.memberId) return
        const result = await axios.get(
          this.DNS_IP +
          `/notify/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`,
          {
            headers: {
              lineUserId: this.profile.userId,
              lineId: this.profile.userId,
              shopId: this.shopId
            }
          }
        )
        if (result.data.length > 0) {
          this.notificationshow = result.data.filter(
            item => item.notifyStatus === 'show'
          )
          this.notificationshowed = result.data.filter(
            item => item.notifyStatus === 'showed'
          )
          this.countNoti = this.notificationshow.length
          if (result.data.find(item => item.notifyStatus === 'showed')) {
            this.text = false
          } else if (result.data.find(item => item.notifyStatus === 'show')) {
            this.text = true
          }
        }
      } catch (err) {
        console.error('err:', err)
      }
    },
    async getReward () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/line/get?redeemStatus=get'
      )
      if (result) {
        try {
          if (Array.isArray(result)) {
            this.items = result.sort(
              (a, b) => new Date(b.endDate) - new Date(a.endDate)
            )
            this.items.filter(item => {
              if (item.endDate) {
                let endDate = new Date(this.momenDate_1(item.endDate)).getTime()
                if (endDate > this.today.getTime()) {
                  this.notExpire += 1
                }
              } else {
                this.notExpire += 1
              }
            })
            // this.notExpire = this.items.filter((a) => new Date(this.momenDate_1(a.endDate)).getTime() > this.today.getTime()).length
          }
        } catch (err) {
          console.error('err:', err)
        }
      }
    },
    async refresh () {
      await this.getMemberProfile()
      if (this.newData) {
        await this.getNotify()
      }
    },
    async removeNoti () {
      this.countNoti = 0
      try {
        await axios.post(
          this.DNS_IP +
          `/update-status-notify/update?lineUserId=${this.profile.userId}&shopId=${this.shopId}`,
          {
            headers: {
              lineUserId: this.profile.userId,
              lineId: this.profile.userId,
              shopId: this.shopId
            }
          }
        )
      } catch (err) {
        console.error('err', err)
      }
      // const result = await this.callBeTaskAPI(
      //   'post',
      //   `/update-status-notify/update?lineUserId=${this.profile.userId}&shopId=${this.member.shopId}`
      // )
      // console.log('update', result)
    },
    adddataToEditData () {
      this.editProfile.nameCustomer = this.newData.nameCustomer
      this.editProfile.tel = this.newData.tel
      this.editProfile.birthDay = this.newData.birthDay
      this.editProfile.picture = this.profile.pictureUrl
    },
    async getExchangeRate () {
      try {
        let response = await axios.get(
          this.DNS_IP +
            '/productExchangeRate/get?shopId=' +
            this.shopId +
            '&changePointTodiscount=True'
        )
        let rs = response.data
        if (rs.length) {
          this.ExchangeRate = rs[0].exchangeRate
          this.checkExchangeRate = true
        } else {
          this.check = true
          this.checkExchangeRate = false
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getPackage () {
      try {
        if (!this.profile || !this.profile.memberId) return
        const result = await this.callBeTaskAPI(
          'get',
          `/PackageLog/getCount?memberId=${this.profile.memberId}&shopId=${this.shopId}`
        )
        if (Array.isArray(result)) {
          this.myPackage = result[0].count
        }
      } catch (err) {
        console.error('err', err)
      }
    },
    async optVerify () {
      try {
        if (this.editProfile.tel !== this.member.tel) {
          let dataCheckTel = await axios.get(
            this.DNS_IP +
              `/member/get?shopId=${this.shopNameData.bpv}&tel=` +
              this.editProfile.tel.trim()
          )
          if (!Array.isArray(dataCheckTel.data)) {
            const result = await axios.post(
              this.DNS_IP + `/OTP/verifyTelePhone`,
              {
                tel: this.editProfile.tel.trim(),
                shopId: this.shopId,
                language: this.$i18n.locale
              }
            )
            if (result.data.status === true) {
              this.otpDialog = true
            }
          } else {
            this.editProfile.tel = this.newData.tel
            Swal.fire({
              title: 'เบอร์นี้ถูกใช้งานแล้ว',
              icon: 'warning',
              confirmButtonText: 'รับทราบ',
              confirmButtonColor: '#3085d6'
            })
          }
        } else {
          this.save('editTel')
          this.otpPassword = ''
          this.otpDialog = false
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async save (a) {
      this.editProfile.nameCustomer = this.editProfile.nameCustomer.replace(
        /'/g,
        "\\'"
      )
      this.editProfile.tel = this.editProfile.tel.replace(/'/g, "\\'")
      try {
        let res = await axios.post(
          this.DNS_IP + `/member/edit/${this.newData.memberId}`,
          this.editProfile
        )
        if (res.data.status === true) {
          await this.getMemberProfile()
          Swal.fire({
            title: 'สำเร็จ',
            text: 'แก้ไขเรียบร้อย',
            icon: 'success',
            confirmButtonText: 'รับทราบ',
            confirmButtonColor: '#3085d6'
          }).then(confirm => {
            if (confirm.isConfirmed) {
              if (a === 'editName') {
                setTimeout(() => {
                  this.editName = false
                }, 500)
                this.editName = false
              } else {
                setTimeout(() => {
                  this.editTel = false
                }, 100)
              }
            }
          })
        }
      } catch (err) {
        console.error('err :', err)
      }
    },

    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    },
    cardColor () {
      return this.isTargetShop ? '#000' : this.$bgColor
    }
  }
}
</script>
<style scoped>
.lmg-font {
  font-family: 'Cordia New', sans-serif !important;
}
.lmg-font * {
  font-family: 'Cordia New', sans-serif !important;
}
.section-navbar ::v-deep .v-sheet.v-card {
  border-radius: 0px !important;

}
.border-8-px{
  border-radius: 8px !important;
}
#primary {
  background-color: #000000;
}
#usercard {
  z-index: 0;
  position: relative;
  min-height: 150px;
}
.theme--light.v-icon {
    color: rgb(255 255 255);
}
.noti {
  color: white;
  background-color: red;
  text-align: center;
  width: 20px;
  height: 20px;
  font-size: 13px;
  border-radius: 50%;
  position: absolute;
  top: 20px;
  right: 10px;
}
.coin_icon::after {
  margin-right: 7px;
  margin-left: 0;
  margin-top: 0;
  content: "";
  background-image: var(--coin_img);
  background-size: 25px 25px;
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: top;
}
.wrap-layer {
  position: relative;
}
.text-layer {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  /* non-critical styles left out */
}
.background-layer:hover #E5 {
  fill: #808;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.materialDesignButton {
  color: #fff;
  border-radius: 5px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 1.04em;
  letter-spacing: 0.05em;
  width: auto;
  transition: 0.3s;
}

.materialDesignButton:hover {
  opacity: 0.7;
}

p {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
}

/* .bubble {
 background-color: #ffffff;
 border-radius: 50%;
 width: 20px;
 height: 20px;
 animation: bounce 3s ease-in-out infinite;
} */
@keyframes bounce4 {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
@keyframes bounce3 {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
}
@keyframes bounce2 {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5px);
  }
}
.bubble1 {
  animation: bounce 5s infinite alternate;
}
.bubble2 {
  animation: bounce2 3s infinite alternate;
}
.bubble3 {
  animation: bounce2 2s infinite alternate;
}
.bubble4 {
  animation: bounce2 6s infinite alternate;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-slide-enter-active {
  transition: all 1s ease;
}

.fade-slide-leave-active {
  transition: all 1s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.bg-181446 {
  /* background-color: #000; */
  background-color: var(--bgColor-nav);
}
</style>



// WEBPACK FOOTER //
// src/components/Layouts/SectionNavbar.vue